module.exports = __webpack_public_path__ + "static/media/undraw_contact_us_15o2.64fb8a6c.svg";